<template>
  <div class="live-card" @click="jumpLiveDetail">
    <van-image
      class="live-cover"
      fit="cover"
      :error-icon="$placeImg"
      :loading-icon="$placeImg"
      :src="cardData.img_url"
      alt=""
    ></van-image>
    <div class="live-msg">
      <div class="live-name ellipsis_two">{{ cardData.name }}</div>
      <div class="live">
        <span>主讲人：{{ cardData.host }}</span>
        <div class="btn">回放</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cardData: {
      type: Object,
      default: {},
      required: true,
      validator: function (value) {
        return value;
      },
    },
  },
  computed: {},
  data() {
    return {};
  },
  onLoad() {},
  methods: {
    jumpLiveDetail( ) {
      let {
        name,
        video_url,
        host,
        img_url,
        category_name,
        video_id,
        ccid,
        cover,
        id
      } = this.cardData;
      let videoId = video_id;
      let type = 'aliyun'
      if (ccid) {
        id = ccid;
        type = 'cc';
      }
      if (video_url) {
        this.$router.push(`./LiveDetail?id=${id}&name=${name}&url=${video_url}&host=${host}&cover=${img_url}&category_name=${category_name}`);
      } else if(videoId){
        this.$router.push(`./LiveDetail?id=${id}&name=${name}&videoId=${videoId}&type=${type}&cover=${cover}`);

      }else{
        this.$toast('没有视频')
      }
      
    },
  },
};
</script>

<style scoped>
.live-card {
  width: 100%;
  height: 167px;
  margin-bottom: 26px;
  display: flex;
  padding: 0 30px;
  box-sizing: border-box;
}

.live-card:last-of-type {
  /* margin-bottom: 0; */
}

.live-cover {
  width: 296px;
  height: 167px;
  border-radius: 12px;
  display: block;
  flex: 0 1 296px;
  margin-right: 26px;
  overflow: hidden;
}

.live-msg {
  flex: 0 1 375px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  width: 375px;
}

.live-name {
  font-size: 32px;
  color: #333;
  font-weight: 600;
  width: 100%;
  margin-bottom: 10px;
}

.live-des {
  font-size: 28px;
  color: #666;
  font-weight: 400;
  width: 100%;
  margin-bottom: 20px;
}


.live {
  font-size: 28px;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.live .btn {
  width: 131px;
  height: 56px;
  background: #F5F5F5;
  border-radius: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #144094;
  font-size: 28px;
  font-weight: 500;
}
</style>>
